import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_5: FaireProductEntity = {
  token: "matcha-5",
  type: "product",
  name: "Matcha Incense",
  brandName: "Oddly specific",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/fb92b8a31ffcbbb9b16fe62ccffc406dd5f9d25ca9d97af538145db9ea1fa99d.png",
  priceDollars: 3,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/fb92b8a31ffcbbb9b16fe62ccffc406dd5f9d25ca9d97af538145db9ea1fa99d.png",
  weight: 0.2,
  dimensions: {
    width: 2,
    height: 6,
    depth: 2,
  },
  description: "Matcha-scented incense sticks",
  categoryTokens: ["cat_accessories"],
  tags: ["matcha", "incense", "wellness", "home-decor", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
